
import resetPasswordModel from '../../models/reset-password.model'
import loginModel from '../../models/login.model'
import { messageComponent } from '../../components/message/message.component';
import ViewBase from '../../views/view-base.view';
import passwordChecker from '../../utils/password-checker';

export default function ResetView () {
  //This view is to reset own password.
  ViewBase.call(this);
  let error = null,
    loading = false,
    submitted = false,
    invalid = false;
  let resetCredentials = { oldPassword: '', newPassword: '', confirmPassword: '', token: '' }
  var isMsgOpen=false;
  var showMsg="";
  var msgTitle="";
  let passwordValidatorList=[];
  function reset (e) {
    e.preventDefault();
    console.log("this is reset password!!");
    submitted = true;
    // resetCredentials.token = loginModel.credentials.token;
    if (!resetCredentials.oldPassword || !resetCredentials.newPassword || !resetCredentials.confirmPassword) return;
    if (resetCredentials.newPassword != resetCredentials.confirmPassword) {
      invalid = true;
      return;
    }
    for (var n = 0; n < passwordValidatorList.length; n++) {
      if (!passwordValidatorList[n].isValid){
        return;
      }
    }

    loading = true;
    error = null;
    resetPasswordModel.reset(
      resetSuccessCallBack,
      resetFailureCallBack,
      resetCredentials.oldPassword,
      resetCredentials.newPassword
    )
  }
  function resetSuccessCallBack (result) {
    console.log("resetSuccessCallBack:"+ JSON.stringify(result) );
    loading = false;
    isMsgOpen=true;
    msgTitle="";
    showMsg=result[0].message;
    resetValue();
  }
  function resetFailureCallBack (err) {
    console.log("resetFailureCallBack:"+JSON.stringify(err));
    loading = false;
    isMsgOpen=true;
    msgTitle="Error!";
    showMsg=err.response[0].message;
  }
  function setOldPassword (e) {
    resetCredentials.oldPassword = e.target.value;
  }

  function setNewPassword (e) {
    resetCredentials.newPassword = e.target.value;
   passwordValidatorList= passwordChecker.check(e.target.value,loginModel.credentials.userID,true)["validateMessages"];
  }

  function setConfirmPassword (e) {
    resetCredentials.confirmPassword = e.target.value
  }
  function resetValue(e){
    console.log("Reset Value");
    submitted = false;
    resetCredentials.oldPassword= "";
    resetCredentials.newPassword = "";
    resetCredentials.confirmPassword = "";
    passwordValidatorList=[];
  }

  function dialogClosed(){
    isMsgOpen=false;
  }

  return {
    view: (vnode) => {
      return[ m('div', 
        [
          m('h3.mb-4',  this.getText("LT00000032", "Reset Password")),
          m('div', {"class":"card"},
          m('div', {"class":"card-body pt-0"},
            m('div', {"class":"row  justify-content-center_"},
              m('div', {"class":"col-md-8"},
                m('div', {"class":"row  mb-2"},
                  
                  m('form', { onsubmit: reset }, [
                    m('br'),
                    m('div', {"class":"row mb-3"},[
                      m("label", {"class":"col-sm-3 col-form-label text-sm-end"}, this.getText("LT00000016", "Old Password")),
                      m('div', {"class":"col-sm-8"},
                        m("input[type='password']", {
                          "class":"form-control form-control-bg",
                          value: resetCredentials.oldPassword,
                          onchange: setOldPassword
                        }),
                        submitted && !resetCredentials.oldPassword &&
                        m(
                          'div', { "class": "invalid-feedback fs-6", style:'display:block;'},
                          m('small', this.getText("EM00000147",'Old Password is required'))
                        )
                      )]
                    ),
                    m('div', {"class":"row mb-3"},[
                      m("label", {"class":"col-sm-3 col-form-label text-sm-end"}, this.getText("LT00000102", "New Password")),
                      m('div', {"class":"col-sm-8"},
                        m("input[type='password']", {
                          "class":"form-control form-control-bg",
                          value: resetCredentials.newPassword,
                          onkeyup: setNewPassword
                        }),
                        submitted && !resetCredentials.newPassword &&
                        m(
                          'div', { "class": "invalid-feedback fs-6", style:'display:block;'},
                          m('small', this.getText("EM00000146",'New Password is required'))
                        ),
                        submitted && invalid &&
                        m(
                          'div', { "class": "invalid-feedback fs-6", style:'display:block;'},
                          m('small', this.getText("EM00000135",'New Password and Confirm Password must be same'))
                        ),
                        passwordValidatorList.map(error =>
                          [
                           !error.isValid && m( 'div', { "class": "invalid-feedback fs-6 d-block"},
                           m('i.bi.bi-x-square.mr-6'),
                              m('small', this.getText(error.code,error.message))
                            ),
                            error.isValid && m( 'div', { "class": "valid-feedback fs-6 d-block"},
                            m('i.bi.bi-check2-square.mr-6'),m('small', this.getText(error.code,error.message))
                          )
                          ])
                      )]
                    ),
                    m('div', {"class":"row mb-3"},[
                      m("label", {"class":"col-sm-3 col-form-label text-sm-end"}, this.getText("LT00000004", "Confirm Password")),
                      m('div', {"class":"col-sm-8"},
                        m("input[type='password']", {
                          "class":"form-control form-control-bg",
                          value: resetCredentials.confirmPassword,
                          onchange: setConfirmPassword
                        }),
                        submitted && !resetCredentials.confirmPassword &&
                        m(
                          'div', { "class": "invalid-feedback fs-6", style:'display:block;'},
                          m('small', this.getText("EM00000134", 'Confirm Password is required'))
                        )
                      )]
                    ),

                    m('div', {"class":"col-md-12  gap-2  d-flex  justify-content-center"},
                      m(
                        "button.btn.btn-primary[type='submit']",
                        this.getText("LT00000005", "Submit")
                      ),
                      m(
                        "button.btn.btn-secondary[type='button']",{ onclick: resetValue },
                        this.getText("LT00000006", "Reset")
                      ),
                    )
                  ])
                )
              )
            )
          )),
          m(messageComponent,{isOpen:isMsgOpen,message:showMsg,title:msgTitle,onClosed:dialogClosed})
        ]), this.getBaseViews()];
    }
  }
}
